import { render, staticRenderFns } from "./VeJwCustomSkjhList.vue?vue&type=template&id=6b0f9b84&scoped=true"
import script from "./VeJwCustomSkjhList.vue?vue&type=script&lang=js"
export * from "./VeJwCustomSkjhList.vue?vue&type=script&lang=js"
import style0 from "./VeJwCustomSkjhList.vue?vue&type=style&index=0&id=6b0f9b84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f9b84",
  null
  
)

export default component.exports